import script from "./TttfBirthday.vue?vue&type=script&setup=true&lang=js"
export * from "./TttfBirthday.vue?vue&type=script&setup=true&lang=js"

import "./TttfBirthday.vue?vue&type=style&index=0&id=3ada6e33&scoped=true&lang=css"
import "./TttfBirthday.vue?vue&type=style&index=1&id=3ada6e33&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d0e91f904bb1d11c0b68168201cc497f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ada6e33"]])

export default __exports__